"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    z-index: 3;\n    position: absolute;\n    top: -68px;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 4px;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme;
  var palette = theme.palette;
  return {
    backgroundColor: palette.elBlack,
    padding: palette.gutter * 2 + 'px',
    color: palette.tInversion,
    fontSize: palette.tsSmall,
    lineHeight: palette.tlSmall,
    boxShadow: "0 8px 12px 0 ".concat(palette.elShadow, ", 0 6px 12px 0 ").concat(palette.elShadow),
    borderRadius: '4px'
  };
};

var Hint = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Hint;
exports["default"] = _default;